export enum OvernightStay {
	WITH_OVERNIGHT_STAY = 'WITH_OVERNIGHT_STAY',
	WITHOUT_OVERNIGHT_STAY = 'WITHOUT_OVERNIGHT_STAY',
}

export const OVERNIGHT_STAYS = [OvernightStay.WITH_OVERNIGHT_STAY, OvernightStay.WITHOUT_OVERNIGHT_STAY];
